<template>
  <div class="order">
    <div class="o_model max-width">
      <!-- 导航菜单 -->
      <div class="o_menu">
        <!-- 报价项目 -->
        <!-- 下面是h5内容显示 -->
        <div class="o_menu_hot_h5">
          <span style="margin-top: 7px">选择报价项目：</span>
          <a-select
            v-model="chanpin"
            style="width: 150px"
            @change="(value) => onChange(value)"
          >
            <a-select-option
              v-for="item in o_hots_h5"
              :key="item.value"
              :value="item.value"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </div>
        <!-- 下面是pc端内容显示 -->
        <div class="o_menu_hot" v-if="!userinfo || (userinfo && !userinfo.head)">
          <div
            style="
              display: flex;
              flex-wrap: wrap;
              margin-left: 100px;
              width: 920px;
            "
          >
            <div
              v-for="(iitem, iindex) in o_hots"
              :key="iindex"
              class="long"
              @mouseenter="func_enter_menu_first"
              @mouseleave="funccccc"
              :data-index="iindex"
              :data-seq="0"
              @click="func_hotMenuu"
              :class="{ longs: iitem.sty }"
            >
              <div class="title">
                {{ iitem.name }}
                <img
                  style="width: 16px; height: 16px; padding-top: 5px"
                  src="@/assets/icon/arrow_down.png"
                  v-if="iitem.jt"
                />
              </div>
              <div class="dropdowns" v-if="iitem.xianshi && iitem.jt">
                <div
                  @click.stop="func_hotMenuu"
                  v-for="(i, seq) in iitem.children"
                  class="add"
                  :data-seq="seq"
                  :data-index="iindex"
                  :key="seq"
                >
                  {{ i.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 常规分类产品 -->
      </div>
      <!-- 产品图片-参数、报价 -->
      <div class="o_content">
        <!-- 产品图片 -->
        <div class="o_con_imgGroup">
          <img class="o_con_imgGroup_img" :src="p_img" />
        </div>
        <!-- 规格参数 -->
        <div class="o_con_production">
          <!-- 信封报价 -->
          <v-xinfeng ref="pidenv_xf"></v-xinfeng>
          <!-- 红包报价 -->
          <v-hongbao ref="pidredenv_hbhb"></v-hongbao>
          <v-wenjiandai ref="pidfilepoc_zbwjd"></v-wenjiandai>
          <!-- 卡套报价 -->
          <v-fangkatao ref="pidcards_zbfkt"></v-fangkatao>
          <v-baikahe ref="pidcards_baikahe"></v-baikahe>
          <v-kuaizitao ref="pidcards_zbkzt"></v-kuaizitao>
          <v-fengtao ref="pidcards_zbft"></v-fengtao>
          <!-- 宣传单报价 -->
          <v-danzhang ref="pidleaflet_zbxcd"></v-danzhang>
          <!-- 非标产品 -->
          <v-feibiaochanpin ref="pidnon_fb"></v-feibiaochanpin>
          <v-pcliandan ref="pidcards_pcliandan"></v-pcliandan>
          <v-wtliandan ref="pidcards_wtliandan"></v-wtliandan>
          <v-gdty ref="pidcards_gdty"></v-gdty>
          <v-kjyp ref="pidcards_kjyp"></v-kjyp>
          <v-kuaidifeng ref="pidcards_kuaidifeng"></v-kuaidifeng>
          <v-bzbg ref="pidcards_bzbg"></v-bzbg>
          <v-bzdah ref="pidcards_bzdah"></v-bzdah>
          <!-- 报价面板 -->
          <div class="o_con_prod_plate">
            <div v-if="offer_string" class="o_con_prod_pl_str">
              {{ offer_string }}
            </div>
            <div class="o_con_prod_pl_str">
              <span
                v-if="offer_price !== 0 && !offer_ing"
                style="font-size: 16px"
                >快递费：<span style="color: #ff6801">{{ kuaidifei }}</span
                >&nbsp;<span v-if="jianmianyunfei !== 0"
                  >元(厂家已减免运费{{ jianmianyunfei }}元)</span
                ></span
              >
              <span
                v-if="offer_price !== 0 && !offer_ing"
                style="font-size: 16px; margin-left: 20px"
                >重量：<span style="color: #ff6801">{{ iWeight }}</span
                >&nbsp;KG</span
              >
            </div>
            <div class="o_con_prod_pl_price theme-font-color">
              <div
                v-if="offer_price !== 0 && !offer_ing"
                class="o_con_prod_pl_pri_name"
              >
                报价:
              </div>
              <div class="o_con_prod_pl_pri_value">
                <span
                  v-if="offer_price !== 0 && !offer_ing"
                  :class="{
                    o_con_prod_pl_pri_value_num_hidden: offer_ing || offer_QQ,
                  }"
                  >￥{{ offer_price + kuaidifei }}</span
                >
                <span
                  :class="{
                    o_con_prod_pl_pri_value_ing: true,
                    o_con_prod_pl_pri_value_ing_show: offer_ing,
                  }"
                  >(报价中)</span
                >
                <span
                  :class="{
                    o_con_prod_pl_pri_value_ing: true,
                    o_con_prod_pl_pri_value_ing_show: offer_QQ,
                  }"
                  >(需联系QQ另行计价)</span
                >
              </div>
            </div>
            <div class="o_con_prod_pl_btn no-copy">
              <div
                v-if="userinfo && this.$parent.isorder"
                class="o_con_prod_pl_btn_view bgcolor-gradient-right font-16"
                @click="func_placeTrolley"
              >
                <div class="o_con_prod_pl_btn_vi_font no-newline">
                  加入购物车
                </div>
              </div>
              <div
                v-if="userinfo && this.$parent.isorder"
                class="o_con_prod_pl_btn_view bgcolor-gradient-right font-16"
                @click="func_placeNow"
              >
                <div class="o_con_prod_pl_btn_vi_font no-newline">立即下单</div>
              </div>
              <div
                v-if="!userinfo"
                class="o_con_prod_pl_btn_view bgcolor-gradient-right font-16"
                @click="func_gotoLogin"
              >
                <div class="o_con_prod_pl_btn_vi_font no-newline">
                  请登录后报价
                </div>
              </div>
              <div
                v-else-if="!userinfo || (userinfo && !userinfo.head)"
                class="o_con_prod_pl_btn_view bgcolor-gradient-right font-16"
                @click="func_loginPlate"
              >
                <div class="o_con_prod_pl_btn_vi_font no-newline">退出登录</div>
              </div>
              <div
                class="o_con_prod_pl_btn_view bgcolor-gradient-right font-16"
                @click="func_qq"
                v-if="this.$parent.isorder"
              >
                <img
                  class="o_con_prod_pl_btn_vi_icon"
                  src="@/assets/icon/qq.png"
                />
                <div class="o_con_prod_pl_btn_vi_font no-newline">联络客服</div>
              </div>
            </div>
          </div>
          <div class="o_con_prod_plate2" v-if="!userinfo || (userinfo && !userinfo.head)">
            <div class="o_con_prod_plate2_singleBox no-copy">
              <template v-for="(item, index) in addressPicker">
                <div
                  :key="item.id"
                  :class="{
                    o_con_prod_plate2_sibo_view: true,
                    color: item.choose,
                    'color-prompt': !item.choose,
                  }"
                  :data-index="index"
                  @click="func_switchAddressPicker"
                >
                  <div
                    :class="{
                      o_con_prod_plate2_sibo_vi_circle: true,
                      'border-color bgcolor-shallow-then': item.choose,
                    }"
                  ></div>
                  <div class="o_con_prod_plate2_sibo_vi_name">
                    {{ item.name }}
                  </div>
                </div>
              </template>
              <div class="peisongfei" v-if="this.$parent.isorder">
                <a href="./static/guize.pdf" style="display: flex">
                  <img class="td_mod_vi_icon" src="@/assets/icon/wenhao.jpeg" />
                  <div class="font-hover font-xhover">配送运费规则</div>
                </a>
              </div>
            </div>
            <div style="display: flex" v-if="isdaifa">
              <div
                style="
                  width: 76px;
                  text-align: center;
                  height: 29px;
                  line-height: 29px;
                  margin-top: 6px;
                  margin-left: 10px;
                  display: none;
                "
              >
                快递公司
              </div>
              <div
                class="o_con_prod_plate2_singleBox no-copy"
                style="display: none"
              >
                <template v-for="(item, index) in kuaidigongsi">
                  <div
                    :key="item.id"
                    :class="{
                      o_con_prod_plate2_sibo_view: true,
                      color: item.choose,
                      'color-prompt': !item.choose,
                    }"
                    :data-index="index"
                    @click="func_kuaidigongsi"
                  >
                    <div
                      :class="{
                        o_con_prod_plate2_sibo_vi_circle: true,
                        'border-color bgcolor-shallow-then': item.choose,
                      }"
                    ></div>
                    <div class="o_con_prod_plate2_sibo_vi_name">
                      {{ item.name }}
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <v-addressCreate ref="vadc" @vadc="vadc"></v-addressCreate>
            <div class="o_con_prod_plate2_addressString color" v-if="true">
              {{ addressPickerString ? addressPickerString : "" }}
            </div>
          </div>
        </div>
      </div>
      <!-- <div
        v-if="this.currentProduct === 'pidredenv_hbhb'"
        class="hongbaotupian"
      >
        <img src="@/assets/order/hbxq/hbxq01.jpg" width="780" />
        <img src="@/assets/order/hbxq/hbxq02.jpg" width="780" />
      </div> -->
    </div>
    <v-fileUpload ref="vflu"></v-fileUpload>
    <v-demonstration ref="demonstration"></v-demonstration>
  </div>
</template>

<script>
import demonstration from '@/components/fileUpload/demonstration';
// 信封报价
import xinfeng from './order/v2020/xinfeng';
// 红包报价
import hongbao from './order/v2020/hongbao';
import wenjiandai from './order/v2020/wenjiandai';
// 卡套报价
import fangkatao from './order/v2020/fangkatao';

import kuaizitao from './order/v2020/kuaizitao';
import fengtao from './order/v2020/fengtao';
// 宣传单报价
import danzhang from './order/v2020/danzhang';
// 非标产品
import feibiaochanpin from './order/v2020/feibiaochanpin';
import pcliandan from './order/v2020/pcliandan';
import wtliandan from './order/v2020/wtliandan';
import bzdah from './order/v2020/bzdah';
import baikahe from './order/v2020/baikahe';
import gdty from './order/v2020/gdty';
import kjyp from './order/v2020/kjyp';
import bzbg from './order/v2020/bzbg';
import kuaidifeng from './order/v2020/kuaidifeng';
import p06 from '@/assets/order/p_06.png';
import fileUpload from '@/components/fileUpload/fileUpload';
import addressCreate from '@/components/address/addressCreate1';
import L01 from '@/assets/order/hongbao/L01.jpg';
import L02 from '@/assets/order/hongbao/L02.jpg';
import L03 from '@/assets/order/hongbao/L03.jpg';
import L04 from '@/assets/order/hongbao/L04.jpg';
import L05 from '@/assets/order/hongbao/L05.jpg';
import L06 from '@/assets/order/hongbao/L06.jpg';
import S01 from '@/assets/order/hongbao/S01.jpg';
import S02 from '@/assets/order/hongbao/S02.jpg';
import S03 from '@/assets/order/hongbao/S03.jpg';
import S04 from '@/assets/order/hongbao/S04.jpg';
import S05 from '@/assets/order/hongbao/S05.jpg';
import S06 from '@/assets/order/hongbao/S06.jpg';


import ML01 from '@/assets/order/hongbao/ML01.jpg';
import ML02 from '@/assets/order/hongbao/ML02.jpg';
import ML03 from '@/assets/order/hongbao/ML03.jpg';
import ML04 from '@/assets/order/hongbao/ML04.jpg';
import ML05 from '@/assets/order/hongbao/ML05.jpg';
import ML06 from '@/assets/order/hongbao/ML06.jpg';
import MS01 from '@/assets/order/hongbao/MS01.jpg';
import MS02 from '@/assets/order/hongbao/MS02.jpg';
import MS03 from '@/assets/order/hongbao/MS03.jpg';
import MS04 from '@/assets/order/hongbao/MS04.jpg';
import MS05 from '@/assets/order/hongbao/MS05.jpg';
import MS06 from '@/assets/order/hongbao/MS06.jpg';

import cyhb from '@/assets/order/hongbao/cyhb.jpg';
import tjhb from '@/assets/order/hongbao/tjhb.jpg';

import BK1 from '@/assets/order/BK1.png';
import BK2 from '@/assets/order/BK2.png';
import BK4 from '@/assets/order/BK4.png';
import BK5 from '@/assets/order/BK5.png';
import BK6 from '@/assets/order/BK6.png';
import BK7 from '@/assets/order/BK7.png';
import BK8 from '@/assets/order/BK8.png';
import BK9 from '@/assets/order/BK9.png';
import BK10 from '@/assets/order/BK10.png';
import PICT from '@/assets/order/p_18.jpg';
import T1 from '@/assets/order/tijianbaogao/hengban.jpg';
import T2 from '@/assets/order/tijianbaogao/shuban.jpg';
import T3 from '@/assets/order/tijianbaogao/kaichuang.jpg';
import T4 from '@/assets/order/p_20.jpg';
import Axios from 'axios';

import {
  req_offer_lishifeng,
  req_offer_heban,
  req_remoteBjlogParams,
} from '@/services/product';
import { req_userMemberRate, req_customer } from '@/services/user';
import { req_bjlogInfo, GetKdf_v2 } from '@/services/order';

export default {
  name: 'order',
  components: {
    'v-demonstration': demonstration,
    'v-xinfeng': xinfeng,
    'v-hongbao': hongbao,
    'v-wenjiandai': wenjiandai,
    'v-fangkatao': fangkatao,
    'v-kuaizitao': kuaizitao,
    'v-fengtao': fengtao,
    'v-danzhang': danzhang,
    'v-feibiaochanpin': feibiaochanpin,
    'v-fileUpload': fileUpload,
    'v-addressCreate': addressCreate,
    'v-pcliandan': pcliandan,
    'v-wtliandan': wtliandan,
    'v-bzdah': bzdah,
    'v-gdty': gdty,
    'v-kjyp': kjyp,
    'v-bzbg': bzbg,
    'v-baikahe': baikahe,
    'v-kuaidifeng': kuaidifeng,
  },
  data() {
    return {
      tableData: [],
      product: [],
      typetable: [
        {
          name: '信封',
          pid: 'pidenv_xf,pidenv_lsf',
        },
        {
          name: '文件袋',
          pid: 'pidfilepoc_zbwjd',
        },
        {
          name: '房卡套',
          pid: 'pidcards_zbfkt',
        },
        {
          name: '筷子套',
          pid: 'pidcards_zbkzt',
        },
        {
          name: '封套',
          pid: 'pidcards_zbft',
        },
        {
          name: '红包',
          pid: 'zhuanbanhongbao,pidredenv_hbhb',
        },
        {
          name: '单张',
          pid: 'pidleaflet_zbxcd',
        },
        {
          name: '电脑打印联单',
          pid: 'pidcards_pcliandan',
        },
        {
          name: '无碳联单',
          pid: 'pidcards_wtliandan',
        },
        {
          name: '便笺表格',
          pid: 'pidcards_bzbg',
        },
        {
          name: '档案盒',
          pid: 'pidcards_kjyp',
        },
        {
          name: '体检报告',
          pid: 'pidcards_bzdah',
        },
        {
          name: '快递封套',
          pid: 'pidcards_zbkuaidifeng',
        },
        // {
        //   name: "白卡盒",
        //   pid: "pidcards_baikahe",
        // },
      ],
      demonstration: false,
      source: null,
      tang: [],
      xhtj: '',
      currentProduct: '', //当前产品
      h5_num: true,
      o_hots: [
        {
          name: '信封',
          xianshi: false,
          oef: '',
          sty: false,
          jt: true, //判断箭头的显示和隐藏
          children: [
            { name: '信封', oef: 'pidenv_xf', choose: false },
            { name: '珠光纸烫金信封', oef: 'pidcards_gdty', choose: false },
          ],
        },
        {
          name: '文件袋',
          xianshi: false,
          oef: '',
          dd: true,
          sty: false,
          jt: false, //判断箭头的显示和隐藏
          children: [
            {
              name: '',
              oef: 'pidfilepoc_zbwjd',
              choose: false,
              sty: false,
            },
          ],
        },
        {
          name: '房卡套',
          xianshi: false,
          oef: '',
          dd: true,
          sty: false,
          jt: false, //判断箭头的显示和隐藏
          children: [
            {
              name: '',
              oef: 'pidcards_zbfkt',
              choose: false,
              sty: false,
            },
          ],
        },
        {
          name: '筷子套',
          xianshi: false,
          oef: '',
          dd: true,
          sty: false,
          jt: false, //判断箭头的显示和隐藏
          children: [
            {
              name: '',
              oef: 'pidcards_zbkzt',
              choose: false,
              sty: false,
            },
          ],
        },
        {
          name: '封套',
          xianshi: false,
          oef: '',
          dd: true,
          sty: false,
          jt: false, //判断箭头的显示和隐藏
          children: [
            {
              name: '',
              oef: 'pidcards_zbft',
              choose: false,
              sty: false,
            },
          ],
        },
        {
          name: '红包',
          xianshi: false,
          oef: '',
          dd: true,
          sty: false,
          jt: false, //判断箭头的显示和隐藏
          children: [
            {
              name: '',
              oef: 'pidredenv_hbhb',
              choose: false,
              sty: false,
            },
          ],
        },
        {
          name: '单张',
          xianshi: false,
          oef: '',
          dd: true,
          sty: false,
          jt: false, //单纯为了判断箭头的显示和隐藏
          children: [
            {
              name: '',
              oef: 'pidleaflet_zbxcd',
              choose: false,
              sty: false,
            },
          ],
        },
        {
          name: '联单',
          xianshi: false,
          oef: '',
          sty: false,
          jt: true, //单纯为了判断箭头的显示和隐藏
          children: [
            { name: '电脑打印联单', oef: 'pidcards_pcliandan', choose: false },
            { name: '无碳联单', oef: 'pidcards_wtliandan', choose: false },
          ],
        },
        {
          name: '便笺表格',
          xianshi: false,
          oef: '',
          dd: true,
          sty: false,
          jt: false, //单纯为了判断箭头的显示和隐藏
          children: [
            {
              name: '',
              oef: 'pidcards_bzbg',
              choose: false,
              sty: false,
            },
          ],
        },
        {
          name: '档案盒',
          xianshi: false,
          oef: '',
          dd: true,
          sty: false,
          jt: false, //单纯为了判断箭头的显示和隐藏
          children: [
            {
              name: '',
              oef: 'pidcards_kjyp',
              choose: false,
              sty: false,
            },
          ],
        },
        {
          name: '体检报告',
          xianshi: false,
          oef: '',
          dd: true,
          sty: false,
          jt: false, //单纯为了判断箭头的显示和隐藏
          children: [
            {
              name: '',
              oef: 'pidcards_bzdah',
              choose: false,
              sty: false,
            },
          ],
        },
        {
          name: '快递封套',
          xianshi: false,
          oef: '',
          dd: true,
          sty: false,
          jt: false, //单纯为了判断箭头的显示和隐藏
          children: [
            {
              name: '',
              oef: 'pidcards_kuaidifeng',
              choose: false,
              sty: false,
            },
          ],
        },
        // {
        //   name: "白卡盒",
        //   xianshi: false,
        //   oef: "",
        //   dd: true,
        //   sty: false,
        //   jt: false, 
        //   children: [
        //     { name: "", oef: "pidcards_baikahe", choose: false, sty: false },
        //   ],
        // },
      ],
      chanpin: 'pidenv_xf',
      o_hots_h5: [
        { name: '信封', value: 'pidenv_xf' },
        { name: '珠光纸烫金信封', value: 'pidcards_gdty' },
        { name: '文件袋', value: 'pidfilepoc_zbwjd' },
        { name: '房卡套', value: 'pidcards_zbfkt' },
        { name: '筷子套', value: 'pidcards_zbkzt' },
        { name: '封套', value: 'pidcards_zbft' },
        { name: '红包', value: 'pidredenv_hbhb' },
        { name: '单张', value: 'pidleaflet_zbxcd' },
        { name: '电脑打印联单', value: 'pidcards_pcliandan' },
        { name: '无碳联单', value: 'pidcards_wtliandan' },
        { name: '便笺表格', value: 'pidcards_bzbg' },
        { name: '档案盒', value: 'pidcards_kjyp' },
        { name: '体检报告', value: 'pidcards_bzdah' },
        { name: '快递封套', value: 'pidcards_kuaidifeng' },
        //{ name: "白卡盒", value: "pidcards_baikahe" },
      ],
      kuaidigongsi: [
      {
          id: '43',
          name: '申通快递',
          choose: true,
          content: false,
          // Tips: "全国",
        },
        {
          id: '42',
          name: '韵达快递',
          choose: true,
          content: false,
          // Tips: "全国",
        },
        {
          id: '41',
          name: '中通快递',
          choose: false,
          content: false,
          // Tips: "全国",
        },
        // {
        //   id: "88",
        //   name: "安能物流(包送货上门)",
        //   choose: false,
        //   content: false,
        //   // Tips: "全国",
        // },
        // { id: "39", name: "顺丰", choose: false, content: false, Tips: "全国" },
      ],
      jianmianyunfei: 0,
      kuaidi100: '',
      leixing: '',
      params: {},
      isdaifa: false,
      cailiao: '', //材料
      yongzhi: '', //用纸
      shuliang: '', //数量
      fangshi: '', //方式
      chichunstrxx: '', //尺寸名称
      chichunstryy: '',
      chichunstr: '',
      o_menu: [],
      userinfo: { head: false },
      offer_ing: false, //请求报价中
      offer_string: '', //报价内容
      offer_price: 0, //请求报价金额
      kuaidifei: 0, //快递费
      iWeight: 0, //重量
      offer_QQ: false, //需要QQ另行报价
      bid: 0,
      p_list: [
        // p01, p02, p03, p04, p05
      ],
      p_img: PICT,
      o_hotss: [],
      isPlaceNow: false, //是否立即下单
      fb_params: {}, //非标产品-规格参数
      address_list: false,
      ziqufangshi: [
        {
          id: '30',
          name: '工厂自取',
        },
        {
          id: '31',
          name: '罗冲围自取',
        },
        {
          id: '32',
          name: '鹤泰路自取',
        },
        {
          id: '33',
          name: '松柏自取',
        },
        {
          id: '32',
          name: '鹤泰路自取',
        },
      ],
      addressPicker: [
        {
          //地址切换
          id: '1',
          name: '默认',
          choose: false,
          content: false,
        },
        {
          //地址切换
          id: '2',
          name: '代发快递',
          choose: false,
          content: false,
        },
        // {
        //   //地址切换
        //   id: "3",
        //   name: "代发专线物流(客户自提货)",
        //   choose: false,
        //   content: false,
        // },
      ],
      shfsshuzu: [
        {
          id: '0',
          name: '自取',
        },
        {
          id: '1',
          name: '物流',
        },
        {
          id: '2',
          name: '代发快递',
        },
      ],
      addressPickerString: '', //显示用地址
      quote_param: {
        material: '',
        shuliang: 0,
        kg: 0,
        lx: '',
      },
      bjlog: null,
      huidiao: '',
    };
  },
  methods: {
    func_enter_menu_first(event) {
      const index = event.currentTarget.dataset.index;
      this.o_hots[index].xianshi = true;
    },
    funccccc() {
      this.o_hots.forEach((item) => {
        item.xianshi = false;
      });
    },
    onChange(name) {
      this.$refs[this.currentProduct].closeChange();
      this.currentProduct = name;
      const result = this.$parent.func_webTab_offerClass(name);
      this.func_init();
      this.offer_price = 0;
      this.offer_QQ = false;
      this.bid = 0;
    },
    //h5切换报价项目
    func_hotMenuu_h5(event) {
      const index = event.currentTarget.dataset.index;
      const seq = event.currentTarget.dataset.seq;
      // 把当前产品的oef传到webTabbar中，按正常流程切换产品分类
      if (this.o_hots_h5[index].jt == true) {
        this.o_hots_h5[index].name = this.o_hots_h5[index].children[seq].name;
      }
      if (this.o_hots_h5[index]['oef']) {
        let content = this.o_hots_h5[index]['oef'];
        this.$refs[content].closeChange();
        this.o_hots_h5[index].sty = true;
        for (let i = 0; i < this.o_hots_h5.length; i++) {
          if (i != index) {
            this.o_hots_h5[i].sty = false;
          }
        }
      } else {
        if (
          this.o_hots_h5[index].children &&
          this.o_hots_h5[index].children[seq].oef
        ) {
          this.o_hots_h5[index].sty = true;
          for (let i = 0; i < this.o_hots_h5.length; i++) {
            if (index == i) {
              this.o_hots_h5[i].sty = true;
            }
            if (index != i) {
              this.o_hots_h5[i].sty = false;
            }
          }
          for (let i in this.o_hots_h5) {
            let count = -1;
            for (let j in this.o_hots_h5[i].children) {
              if (this.o_hots_h5[i].children[j]['choose']) {
                this.o_hots_h5[i].children[j]['choose'] = false;
                const rClose = this.o_hots_h5[i].children[j]['oef'];
                this.$refs[rClose].closeChange();
                count += 1;
                break;
              }
            }
            if (count > -1) {
              break;
            }
            if (parseInt(i) === this.o_hots_h5.length - 1 && count === -1) {
              for (let j in this.o_menu) {
                if (this.o_menu[j]['choose']) {
                  const rClose = this.o_menu[j]['oef'];
                  this.$refs[rClose].closeChange();
                  break;
                }
              }
            }
          }
        }
      }
      if (this.o_hots_h5[index]['oef']) {
        const oef = this.o_hots_h5[index]['oef'];
        this.currentProduct = oef;
        const result = this.$parent.func_webTab_offerClass(oef);
        this.func_init();
      } else {
        const oef = this.o_hots_h5[index].children[seq]['oef'];
        this.currentProduct = oef;
        const result = this.$parent.func_webTab_offerClass(oef);
        this.func_init();
      }
      // 重置面板内容
      this.offer_price = 0;
      this.offer_QQ = false;
      this.bid = 0;
    },
    // pc切换报价项目
    func_hotMenuu(event) {
      const index = event.currentTarget.dataset.index;
      const seq = event.currentTarget.dataset.seq;
      // 把当前产品的oef传到webTabbar中，按正常流程切换产品分类
      this.o_hots[0].name = '信封';
      this.o_hots[7].name = '联单';
      this.o_hots[index].xianshi = false;
      if (this.o_hots[index].jt == true) {
        this.o_hots[index].name = this.o_hots[index].children[seq].name;
      }
      if (this.o_hots[index]['oef']) {
        let content = this.o_hots[index]['oef'];
        this.$refs[content].closeChange();
        this.o_hots[index].sty = true;
        for (let i = 0; i < this.o_hots.length; i++) {
          if (i != index) {
            this.o_hots[i].sty = false;
          }
        }
      } else {
        if (
          this.o_hots[index].children &&
          this.o_hots[index].children[seq].oef
        ) {
          this.o_hots[index].sty = true;
          for (let i = 0; i < this.o_hots.length; i++) {
            if (index == i) {
              this.o_hots[i].sty = true;
            }
            if (index != i) {
              this.o_hots[i].sty = false;
            }
          }
          for (let i in this.o_hots) {
            let count = -1;
            for (let j in this.o_hots[i].children) {
              if (this.o_hots[i].children[j]['choose']) {
                this.o_hots[i].children[j]['choose'] = false;
                const rClose = this.o_hots[i].children[j]['oef'];
                this.$refs[rClose].closeChange();
                count += 1;
                break;
              }
            }
            if (count > -1) {
              break;
            }
            if (parseInt(i) === this.o_hots.length - 1 && count === -1) {
              for (let j in this.o_menu) {
                if (this.o_menu[j]['choose']) {
                  const rClose = this.o_menu[j]['oef'];
                  this.$refs[rClose].closeChange();
                  break;
                }
              }
            }
          }
        }
      }
      if (this.o_hots[index]['oef']) {
        const oef = this.o_hots[index]['oef'];
        this.currentProduct = oef;
        const result = this.$parent.func_webTab_offerClass(oef);
        this.func_init();
      } else {
        const oef = this.o_hots[index].children[seq]['oef'];
        this.currentProduct = oef;
        const result = this.$parent.func_webTab_offerClass(oef);
        this.func_init();
      }
      // 重置面板内容
      this.offer_price = 0;
      this.offer_QQ = false;
      this.bid = 0;
    },
    func_loginPlate() {
      this.$parent.func_appLoginOut();
    },
    // 去登录
    func_gotoLogin() {
      if (this.$parent.isorder) {
        this.$router.push({
          name: 'home',
        });
      } else {
        //遮罩的显示和隐藏
        if (!this.demonstration) {
          this.$refs.demonstration.open();
        } else {
          this.$refs.demonstration.close();
        }
      }
    },
    // 联络客服
    func_qq() {
      window.open('tencent://message/?uin=800180939');
    },
    vadc(e) {
      this.huidiao = e;
      if (this.addressPicker[1].choose && this.leixing !== 'pidnon_fb') {
        this.func_kuaidifei(1);
      }
    },
    //限制
    func_xianzhi() {
      //下单信息限制
      let hui = true;
      // if (this.params.iWeight < 300 && this.addressPicker[2].choose) {
      //   this.$parent.msgChange("warning", "重量低于300kg不支持专线物流", "");
      //   hui = false;
      //   return;
      // }
      if (this.addressPicker[0].choose == false) {
        if (this.huidiao) {
          for (var i = 0; i < this.huidiao.length; i++) {
            if (
              (this.huidiao[i].id === 'adel04' ||
                this.huidiao[i].id === 'adel01' ||
                this.huidiao[i].id === 'adel02') &&
              this.huidiao[i].value === ''
            ) {
              this.$parent.msgChange(
                'warning',
                '请完善' + this.huidiao[i].name,
                ''
              );
              hui = false;
            } else if (
              this.huidiao[i].id === 'adel06' &&
              this.huidiao[i].value[2] === ''
            ) {
              this.$parent.msgChange(
                'warning',
                '请完善' + this.huidiao[i].name,
                ''
              );
              hui = false;
            }
          }
        } else {
          this.$parent.msgChange('warning', '请完善收货信息', '');
          hui = false;
        }
      }
      return hui;
    },
    // 立即下单
    func_placeNow() {
      if (!this.func_xianzhi()) {
        return;
      }
      this.isPlaceNow = true;
      // 照常执行'加入购物车流程'
      this.func_openFileUpload();
    },
    // 加入购物车
    func_placeTrolley() {
      if (!this.func_xianzhi()) {
        return;
      }
      this.isPlaceNow = false;
      this.func_openFileUpload();
    },
    // 打开'文件上传'窗口
    func_openFileUpload() {
      if (this.offer_QQ) {
        this.$parent.msgChange('warning', '需要QQ联系获取报价', '');
        return;
      } else if (this.offer_ing) {
        this.$parent.msgChange('warning', '报价金额获取中，请稍等', '');
        return;
      } else if (parseFloat(this.offer_price) <= 0) {
        if (this.currentProduct !== 'pidnon_fb') {
          this.$parent.msgChange(
            'warning',
            '报价金额不正确，请先获取报价金额',
            ''
          );
          return;
        }
      }
      let currentPaper = '';
      let GramWeight = '';
      if (this.currentProduct !== 'pidnon_fb') {
        if (this.cailiao == '5') {
          currentPaper = '双胶';
          GramWeight = this.yongzhi;
        } else if (this.cailiao == '9') {
          currentPaper = '黄牛皮';
          GramWeight = this.yongzhi;
        } else if (this.cailiao == '14') {
          currentPaper = '白牛皮';
          GramWeight = this.yongzhi;
        } else if (this.cailiao == '1') {
          currentPaper = '双铜';
          GramWeight = this.yongzhi;
        } else if (this.cailiao == '2') {
          currentPaper = '单铜';
          GramWeight = this.yongzhi;
        } else if (this.cailiao == '3') {
          currentPaper = '哑粉';
          GramWeight = this.yongzhi;
        } else if (this.cailiao == '6') {
          currentPaper = '灰底白';
          GramWeight = this.yongzhi;
        } else if (this.cailiao == '7') {
          currentPaper = '白底白';
          GramWeight = this.yongzhi;
        } else if (this.cailiao == '13') {
          currentPaper = '冰白';
          GramWeight = this.yongzhi;
        } else if (this.cailiao == '20672') {
          currentPaper = '双铜';
          GramWeight = this.yongzhi;
        } else if (this.cailiao == '11853') {
          currentPaper = '艳红';
          GramWeight = this.yongzhi;
        } else if (this.cailiao == '11854') {
          currentPaper = '触感红';
          GramWeight = this.yongzhi;
        } else if (this.cailiao == '11852') {
          currentPaper = '鲜红';
          GramWeight = this.yongzhi;
        } else if (this.cailiao == '12534') {
          currentPaper = '白卡纸';
          GramWeight = this.yongzhi;
        } else if (this.cailiao == '12535') {
          currentPaper = '双铜纸';
          GramWeight = this.yongzhi;
        } else {
          let qiege = [];
          qiege = this.cailiao.split('克');
          currentPaper = qiege[1];
          GramWeight = qiege[0];
          if (currentPaper == '牛皮纸') {
            currentPaper = '黄牛皮';
          }
        }
      }
      this.$refs.vflu.vflu_Change1(
        currentPaper || '',
        GramWeight || '',
        this.shuliang,
        this.currentProduct,
        this.chichunstr,
        this.chichunstrxx,
        this.chichunstryy,
        this.fangshi,
        this.offer_string,
        this.danshuang
      );
    },
    //接收规格参数-获取处理报价
    async func_quotation(type, params) {
      this.params = params;
      this.leixing = type;
      if (
        params.daomo &&
        type !== 'zhuanbanhongbao' &&
        type !== 'pidredenv_hbhb'
      ) {
        if (params.daomo == 1) {
          params.hjg.push('定制刀模');
        } else if (params.daomo == 0) {
          params.hjg.push('标准刀模');
        }
      }

      if (params.leixing === '现货加烫金') {
        this.xhtj = params.cailiao;
        params['cailiao'] = params['materialname'];
      }
      if (
        params.cailiao === '1' ||
        params.cailiao === '17831' ||
        params.cailiao === '13'
      ) {
        this.tang = [];
        for (let i in params['hjg']) {
          if (params['hjg'][i].indexOf('浮雕烫') >= 0) {
            let j = parseInt(i) + 1;
            this.tang.push(params['hjg'][i]);
            this.tang.push(params['hjg'][j]);
            params['hjg'].splice(i, 2);
          } else if (params['hjg'][i].indexOf('平烫') >= 0) {
            this.tang.push(params['hjg'][i]);
            params['hjg'].splice(i, 1);
          }
        }
      }
      this.cailiao = params.cailiao;
      this.yongzhi = params.yongzhi;
      this.shuliang = params.shuliang;
      this.fangshi = params.fangshi ? params.fangshi : params.xfys;
      this.danshuang = params.danshuang ? params.danshuang : '';
      this.chichunstrxx = params.xx;
      this.chichunstryy = params.yy;
      this.chichunstr = params.chichunstr ? params.chichunstr : params.yongzhi;
      if (!this.userinfo || !this.userinfo['userid']) {
        return;
      } else if (type === 'pidnon_fb') {
        // 非标产品-不用此流程
        this.fb_params = params;
        this.offer_string = '';
        return;
      } else {
        this.fb_params = {};
      }
      for (let i = 0; i < this.o_hots.length; i++) {
        for (let j = 0; j < this.o_hots[i].children.length; j++) {
          if (this.o_hots[i].children[j].oef == type) {
            this.o_hots[i].sty = true;
          }
        }
      }
      for (let i = 0; i < this.o_hots.length; i++) {
        for (let j = 0; j < this.o_hots[i].children.length; j++) {
          if (
            this.o_hots[i].children[j].oef == type &&
            this.o_hots[i].jt == true
          ) {
            this.o_hots[i].name = this.o_hots[i].children[j].name;
          }
        }
      }

      this.offer_string = params['string'];

      this.offer_string = this.offer_string.replace(
        '1号信封(165X100mm)',
        '1号信封'
      );
      this.offer_string = this.offer_string.replace(
        '2号信封(175X110mm)',
        '2号信封'
      );
      this.offer_string = this.offer_string.replace(
        '3号信封(B6号 176X125mm)',
        '3号信封'
      );
      this.offer_string = this.offer_string.replace(
        '5号信封(DL号 220X110mm)',
        '5号信封'
      );
      this.offer_string = this.offer_string.replace(
        '6号信封(ZL号 230X120mm)',
        '6号信封'
      );
      this.offer_string = this.offer_string.replace(
        '7号信封(C5号 229X162mm)',
        '7号信封'
      );
      this.offer_string = this.offer_string.replace(
        '8号信封(250X162mm)',
        '8号信封'
      );
      this.offer_string = this.offer_string.replace(
        '9号信封(C4号 324X229mm)',
        '9号信封'
      );
      this.offer_string = this.offer_string.replace('自定义展开尺寸', '展开');
      this.offer_string = this.offer_string.replace('使用定制刀模', '新板');
      this.offer_string = this.offer_string.replace('使用标准刀模', '标板');
      this.offer_string = this.offer_string.replace('定制刀模', '新板');
      this.offer_string = this.offer_string.replace('标准刀模', '标板');
      this.offer_string = this.offer_string.replace('单面哑膜', '单面哑膜');
      this.offer_string = this.offer_string.replace('单面亮膜', '单面光膜');
      this.offer_string = this.offer_string.replace('模切', '啤');
      this.offer_string = this.offer_string.replace('切成品', '切');
      this.offer_string = this.offer_string.replace(
        '带自粘(打口水胶)',
        '打口水胶'
      );
      //需QQ另行报价
      if (params['need_QQoffer']) {
        this.offer_QQ = true;
        this.offer_price = 0;
        return;
      } else {
        this.offer_QQ = false;
      }
      if (!this.$parent.isorder) {
        params.isagent = 1;
      }
      // 请求'初始基本'报价
      this.offer_ing = true; //打开'报价中'状态
      this.offer_price = 0;
      const result = await this.quotationChange(type, params);
      if (!result.success) {
        this.offer_ing = false;
        this.offer_price = 0;
        return;
      }
      let price = parseInt(result.data['sprice']);
      if (!this.$parent.isorder) {
        const oldprice = JSON.parse(JSON.stringify(price));
        //先计算产品利润，在计算价格区间利润，再和最小利润对比
        for (let n in this.product) {
          for (let m in this.typetable) {
            if (this.product[n].Name == this.typetable[m].name) {
              this.product[n].pid = this.typetable[m].pid;
            }
          }
        }
        // for (let j in this.product) {
        //   if (this.product[j].pid.indexOf(type) >= 0) {
        //     price = price * (1 + this.product[j].profitrate / 100);
        //     break;
        //   }
        // }
        for (let i in this.tableData) {
          if (
            Math.ceil(price) >= this.tableData[i].min &&
            Math.ceil(price) < this.tableData[i].max
          ) {
            price = price * (1 + this.tableData[i].percentage / 100);
            let zq = price - oldprice;
            if (zq < this.tableData[i].fix) {
              price = oldprice + this.tableData[i].fix;
            }
            break;
          }
        }
        price = Math.ceil(price);
      }
      // 根据logid是否存在，判断是否需要加上用户利率报价
      const logid = result.data['logid'];
      this.bid = result.data['bid'];
      let bid = this.bid;
      // 标准不需要调'插入bjlog'
      // console.log(logid)
      // && type!=='pidcards_baikahe'
      if (!logid) {
        this.func_remoteBjlog(bid)
          .then(() => {
            const result = req_bjlogInfo(bid);
            return result;
          })
          .then((result) => {
            let data = result.data;
            let errMsg = '';
            // console.log(this.quote_param,data,type)
            if (
              this.quote_param.lx &&
              data.lx &&
              this.quote_param.lx != undefined &&
              data.lx !== undefined &&
              data.lx.indexOf(this.quote_param.lx) < 0 &&
              data.lx.indexOf('展开') < 0
            ) {
              errMsg = '规格不一致';
            } else if (this.quote_param.shuliang != data.shuliang) {
              errMsg = '数量不一致';
            } else if (this.quote_param.kg != data.kg) {
              errMsg = '克重不一致';
            } else {
              this.bjlog == data;
            }
            if (errMsg !== '' && data.qid !== 21) {
              //名片位房卡套不检测文件
              this.$parent.msgChange('warning', errMsg, '');
              this.offer_QQ = true;
              this.offer_price = 0;
              this.offer_ing = false;
              this.bid = 0;
            }
          });
      }
      // 标准不需要加上用户利率
      if (price > 0 && !logid) {
        price = await this.quotation_rate(price);
      }
      if (
        (type == 'pidcards_zbft' ||
          type == 'pidcards_bzdah' ||
          type == 'pidcards_zbkuaidifeng') &&
        params.daomo == 0
      ) {
        price = Number(price) - 60;
      }
      let hbtangjin = 0
      if (type == 'pidredenv_hbhb' && params.hjg.includes('单面加LOGO')){
        hbtangjin = Number(params.shuliang)*Number(params.pinzhong) * 0.04
        if (hbtangjin < 40){
          hbtangjin = 40
        }
        hbtangjin += 10
      } else if (type == 'pidredenv_hbhb' && params.hjg.includes('双面加LOGO')){
        hbtangjin = Number(params.shuliang) * Number(params.pinzhong) * 0.08
        if (hbtangjin < 80){
          hbtangjin = 80
        }
        hbtangjin += 20
      }
      price += hbtangjin
      this.offer_price = price;
      // console.log(this.userinfo);
      let id = '';
      let wlfs = '';
      if (this.addressPicker[0].choose) {
        if (this.userinfo.binding1 == 44 && this.userinfo.wlid == 0) {
          wlfs = '中通快递';
          id = 1;
        } else {
          for (let n in this.kuaidigongsi) {
            if (
              this.kuaidigongsi[n].id == this.userinfo.wlid &&
              (this.userinfo.shfs == 2 || this.userinfo.binding1 == '44')
            ) {
              wlfs = this.kuaidigongsi[n].name;
              id = 1;
              break;
              //需要计算快递费
            } else {
              //无需计算快递费
              id = 2;
            }
          }
        }
      } else if (this.addressPicker[1].choose) {
        id = 1;
        for (let aaa in this.kuaidigongsi) {
          if ((this, this.kuaidigongsi[aaa].choose)) {
            this.$refs.vadc.vadc_json(aaa);
          }
        }
      } else if (this.addressPicker[2].choose) {
        id = 2;
      }
      if (this.leixing == 'pidnon_fb') {
        this.kuaidifei = 0;
      } else {
        this.func_kuaidifei(id, wlfs);
      }

      this.offer_ing = false;
    },
    cancelRequest() {
      if (typeof this.source === 'function') {
        this.source();
      }
    },
    //请求报价
    async quotationChange(type, params) {
      if (!params) {
        return {
          success: false,
          msg: 'function quotationChange miss params',
        };
      }

      delete params['need_QQoffer'];
      delete params['string'];
      this.cancelRequest();
      // 专版宣传单不需要uid
      let rnd = Math.random();
      params.rnd = rnd;
      if (
        type !== 'pidleaflet_zbxcd' &&
        type !== 'pidleaflet_zbhb' &&
        type !== 'pidleaflet_zbxcd'
      ) {
        params['uid'] = this.userinfo['userid'];
      }
      let result = {};
      const arr = [
        'pidenv_xf',
        'pidredenv_hbhb',
        'pidfilepoc_hbwjd',
        'pidcards_hbfkt',
        'pidcards_hbkzt',
        'pidcards_hbft',
        'pidleaflet_hbxcd',
        'pidcards_pcliandan',
        'pidcards_wtliandan',
        'pidcards_gdty',
        'pidcards_kjyp',
        'pidcards_bzbg',
        'pidcards_kuaidifeng',
      ];
      if (arr.indexOf(type) === -1) {
        this.quote_param.lx = params.chichunstr;
        this.quote_param.kg = params.yongzhi;
        this.quote_param.shuliang = params.shuliang;
        this.quote_param.cailiao = params.materialname;
        this.quote_param.xfys = params.xfys;

        if (params.xfys == '西式开窗') {
          params.xfys = '西式';
        }
        delete params['materialname'];
        // 专版报价
        let zhzd = '';
        if (params.zhzd) {
          zhzd = params.zhzd;
        } else {
          zhzd = '';
        }
        params.zhzd = null;

        result = await req_offer_lishifeng(params);
        if (result.data) {
          result.data = await this.xmlToJson(result.data, 'price');
          if (parseInt(result.data['sprice']) > 0) {
            result['success'] = true;
          } else {
            result['success'] = false;
          }
          if (params.pinzhong) {
            result.data.sprice = result.data.sprice * params.pinzhong;
          }
          console.log(type,zhzd)
          if (type == 'pidenv_lsf' && this.quote_param.xfys == '西式开窗') {
            //西式开窗增加开窗费用
            if (params.shuliang <= 1000) {
              result.data.sprice += 80;
            } else {
              result.data.sprice += params.shuliang * 0.08;
            }
          } else if (type == 'zhuanbanhongbao' && zhzd) {
            let mo = 0;
            if (zhzd == '扎红纸带-100个/扎') {
              mo = Math.ceil(params.shuliang / 100) * 0.5;
            } else if (zhzd == '扎红纸带-50个/扎') {
              mo = Math.ceil(params.shuliang / 50) * 0.5;
            }
            if (mo < 20) {
              mo = 20;
            }
            result.data.sprice += mo;
          } else if (
            type == 'pidcards_zbfkt' &&
            params.qid == 11 &&
            params.daomo == 0
          ) {
            result.data.sprice = result.data.sprice - 60;
            console.log('标版优惠60');
          } else if (
            type == 'pidcards_zbfkt' &&
            params.qid == 21 &&
            params.chichunstr.indexOf('对折') >= 0
          ) {
            result.data.sprice = result.data.sprice * 1.07;
            console.log('对折式95折');
          }
          // console.log(type, this.params);

          return result;
        } else {
          result['success'] = false;
          result['msg'] = result['data']['Description'];
          return result;
        }
      } else {
        // 标准报价
        result = await req_offer_heban(params);
        if (result.success && result.data.success) {
          result['data']['bid'] = result['data']['logid'];
          if (
            parseInt(result['data']['sprice']) > 0 &&
            result.data.rnd &&
            result.data.rnd == params.rnd
          ) {
            result['success'] = true;
          } else {
            result['success'] = false;
          }
        } else {
          result['success'] = false;
        }
        return result;
      }
    },
    //快递公司切换
    func_kuaidigongsi(event) {
      const { index } = event.currentTarget.dataset;
      this.kuaidigongsi.forEach((f, i) => {
        if (f.choose && i !== index) f.choose = false;
      });
      this.kuaidigongsi[index].choose = true;
      this.kuaidi100 = this.kuaidigongsi[index].name;
      this.$refs.vadc.vadc_json(index);
      if (this.leixing == 'pidnon_fb') {
        this.kuaidifei = 0;
      } else {
        this.func_kuaidifei(1);
      }
    },
    //快递费计算
    func_kuaidifei(id, wlfs) {
      let kdgs = '';
      let zhizhong = 0;
      let params = this.params;
      let xx = params.xx;
      let yy = params.yy;
      let shuliang = params.shuliang;
      let iWeight = 0;
      let sheng = '';
      let shi = '';
      let pinzhong = params.pinzhong ? params.pinzhong : 1;
      let kuaidifei = 0;
      for (let i in this.kuaidigongsi) {
        if (this.kuaidigongsi[i].choose) {
          kdgs = this.kuaidigongsi[i].name;
        }
      }
      if (this.leixing == 'pidcards_wtliandan') {
        zhizhong = 52 * 100;
      } else if (this.leixing == 'pidcards_pcliandan') {
        if (params.lianshu == '二联') {
          zhizhong = 110;
          shuliang = params.shuliang * 2000;
        } else if (params.lianshu == '三联') {
          zhizhong = 165;
          shuliang = params.shuliang * 1330;
        } else if (params.lianshu == '四联') {
          zhizhong = 220;
          shuliang = params.shuliang * 1000;
        } else if (params.lianshu == '五联') {
          zhizhong = 275;
          shuliang = params.shuliang * 800;
        }
      } else if (this.leixing == 'pidcards_bzbg') {
        zhizhong = params.cailiao.replace(/[^\d]/g, ' ');
        zhizhong = parseInt(zhizhong) * 100;
      } else if (this.leixing == 'pidredenv_hbhb') {
        zhizhong = 240
      } else {
        if (params.yongzhi) {
          zhizhong = params.yongzhi;
          zhizhong = parseInt(zhizhong);
        } else {
          zhizhong = params.cailiao.replace(/[^\d]/g, ' ');
          zhizhong = parseInt(zhizhong);
        }
      }
      if (zhizhong<=10){
        zhizhong = 160
      }
      iWeight =
        (parseInt(xx) *
          parseInt(yy) *
          parseInt(shuliang) *
          parseInt(zhizhong) *
          parseInt(pinzhong)) /
        (1000 * 1000 * 1000);
      this.params.iWeight = iWeight;
      if (wlfs && wlfs !== '') {
        sheng = this.userinfo.province;
        shi = this.userinfo.city;
        kdgs = wlfs;
      } else {
        for (let j in this.huidiao) {
          if (this.huidiao[j].name == '收货地区') {
            sheng = this.huidiao[j].value[0];
            shi = this.huidiao[j].value[1];
          }
        }
      }
      if (this.jianmianyunfei != 0) {
        this.jianmianyunfei = 0;
      }
      if (id == 1) {
        kuaidifei = GetKdf_v2(kdgs, iWeight, sheng, shi);
      } else {
        kuaidifei = 0;
      }
      if (this.userinfo && this.userinfo.userid == 1025){
        kuaidifei = 0
      }
      this.iWeight = iWeight.toFixed(1);
      this.kuaidifei = Math.round(kuaidifei);
    },
    // 计算利率报价
    quotation_rate(price) {
      return new Promise(async (resolve, reject) => {
        const result = await req_userMemberRate(this.userinfo['userid']);
        if (result.success) {
          const rateJson = [
            {
              price: parseInt(result.data.ubound1),
              profit: parseFloat(result.data.use1 / 100),
            },
            {
              price: parseInt(result.data.ubound2),
              profit: parseFloat(result.data.use2 / 100),
            },
            {
              price: parseInt(result.data.ubound3),
              profit: parseFloat(result.data.use3 / 100),
            },
            {
              price: parseInt(result.data.ubound4),
              profit: parseFloat(result.data.use4 / 100),
            },
          ];
          let count = -1;
          for (let i in rateJson) {
            if (price <= rateJson[i].price) {
              count = parseInt(i);
              break;
            }
          }
          if (count !== -1) {
            price = price + price * rateJson[count].profit;
          } else {
            //超出利率标准范围-使用最大利率
            price = price + price * parseFloat(result.data.use5 / 100);
          }
          resolve(parseInt(price));
        } else {
          resolve(price);
        }
      });
    },
    //============================================================================================================================
    // xml转json
    async xmlToJson(xmlString, targetNamePrice, targetNameBid) {
      return new Promise((resolve, reject) => {
        let xmlDoc = null;
        let domParser = false;
        //判断浏览器的类型
        if (!window.DOMParser && window.ActiveXObject) {
          //支持ie
          let xmlDomVersions = [
            'MSXML.2.DOMDocument.6.0',
            'MSXML.2.DOMDocument.3.0',
            'Microsoft.XMLDOM',
          ];
          for (let i = 0; i < xmlDomVersions.length; i++) {
            try {
              xmlDoc = new ActiveXObject(xmlDomVersions[i]);
              xmlDoc.async = false;
              xmlDoc.loadXML(xmlString); //loadXML方法载入xml字符串
              break;
            } catch (e) {}
          }
        } else if (
          window.DOMParser &&
          document.implementation &&
          document.implementation.createDocument
        ) {
          //支持Mozilla
          try {
            domParser = new DOMParser();
            xmlDoc = domParser.parseFromString(xmlString, 'text/xml');
          } catch (e) {}
        } else {
          return null;
        }

        let xmlPrice = xmlDoc.getElementsByTagName(targetNamePrice)[0];
        //报价id
        const xmlBid = xmlDoc.getElementsByTagName('logid')[0].textContent;
        xmlPrice = {
          shuliang: xmlPrice.attributes.shuliang.nodeValue,
          sprice: xmlPrice.attributes.sprice.nodeValue,
          pf: xmlPrice.attributes.pf.nodeValue,
          bid: xmlBid,
        };

        resolve(xmlPrice);
      });
    },
    // 抓取远程bjlog库-存储bjlog信息
    async func_remoteBjlog(bid) {
      const result = await req_remoteBjlogParams(this.userinfo['userid'], bid);
    },

    //============================================================================================================================
    // 文件上传
    func_uploadIng(file) {
      //判断文件所属产品类型

      let file_belong = 'pbbgj';

      let formData = new FormData();
      formData.append('name', 'Alax');
      formData.append('imagefile', file);
      formData.append('fileFloatType', file_belong);
      const config = {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (e) => {
          if (e.lengthComputable) {
            const rate = e.loaded / e.total; //已上传的比例
            if (rate < 1) {
              const proging = (rate * 100).toFixed(2);
              // this.uploadWidth = (rate *100).toFixed(2);
              this.$refs.vflu.vflu_uploadIng(proging);
            }
          }
        },
      };

      const url = 'http://www.yin2015.com:8080/vip/newattachmgr/upload';
      Axios.post(url, formData, config).then((data) => {
        const json = data.data;
        if (json.statusCode === 200) {
          //保存接口返回的文件路径、文件名-$parent
          const temp = json.forwardUrl.split('&&');
          this.$refs.vflu.vflu_uploadIng('100.00');
          this.func_trolleyInsert(file.name, temp[0], temp[1], file.fileSize);
        } else {
          this.$refs.vflu.vflu_uploadIng(-1);
          //上传失败
          // this.$parent.dialogueChange(true, '文件上传失败......' + json.msg, () => {});
          //回调重置上传窗口
          // this.$refs.fileUpload.resetFileUpload();
        }
      });
    },
    //============================================================================================================================
    //获取当前日期
    func_currentDate() {
      const nowDate = new Date();
      const year = nowDate.getFullYear();
      const month = nowDate.getMonth() + 1;
      const date = nowDate.getDate();
      const hours = nowDate.getHours();
      const minutes = nowDate.getMinutes();
      const miao = nowDate.getSeconds();
      const left =
        year +
        '-' +
        (month < 10 ? '0' + month : month) +
        '-' +
        (date < 10 ? '0' + date : date);
      const right = hours + ':' + minutes + ':' + miao;
      return left + ' ' + right;
    },
    //加入购物车
    func_trolleyInsert(
      uploadedfilenameold,
      uploadedfilepath,
      uploadedfilename,
      fileSize
    ) {
      // 1)
      let trollerList = this.STORAGE.get('g_trollerList');
      if (!trollerList || trollerList.length < 1) trollerList = [];
      // 2)
      let proName = '';
      let proOef = '';
      for (let i in this.o_menu) {
        if (this.o_menu[i].choose) {
          proName = this.o_menu[i].name;
          proOef = this.o_menu[i].oef;
          break;
        }
      }
      // 3)
      const fastAddr = this.addressPicker.find((p) => p.choose).content;
      //非标产品-加入购物车时(金额等参数特殊获取)
      if (proOef === 'pidnon_fb') {
        trollerList.push({
          uploadedfilenameold: uploadedfilenameold,
          uploadedfilepath: uploadedfilepath,
          uploadedfilename: uploadedfilename,
          uploadedfilesize: fileSize,
          bid: '57221780',
          offerInfoString: this.fb_params['string'],
          offerInfoPrice: this.fb_params['price'],
          fbPrice: this.fb_params['price'] ? this.fb_params['price'] : 0,
          remark: this.fb_params['remark'], //备注
          g_address: fastAddr, //收货地址
          productName: proName,
        });
      } else {
        let wlfs = '';
        if (this.userinfo.binding1 == 44 && this.userinfo.wlid == 0) {
          wlfs = '中通快递';
        } else {
          for (let n in this.kuaidigongsi) {
            if (
              this.kuaidigongsi[n].id == this.userinfo.wlid &&
              (this.userinfo.shfs == 2 || this.userinfo.binding1 == '44')
            ) {
              wlfs = this.kuaidigongsi[n].name;
              break;
              //需要计算快递费
            }
          }
        }
        trollerList.push({
          uploadedfilenameold: uploadedfilenameold,
          uploadedfilepath: uploadedfilepath,
          uploadedfilename: uploadedfilename,
          uploadedfilesize: fileSize,
          bid: this.bid,
          g_bjlog: this.bjlog,
          // qid: qid,
          wlfs: wlfs,
          kuaidifei: this.kuaidifei,
          offerInfoString: this.offer_string,
          offerInfoPrice: this.offer_price,
          remark: '', //备注
          g_address: fastAddr, //收货地址
          productName: proName,
        });
      }
      // 3)
      this.STORAGE.set('g_trollerList', trollerList);
      // 4) 清除重置
      // 6) 通知导航栏-购物车数量改变
      this.$parent.func_tabbar_trolley();
      this.$router.push({
        name: 'trolley',
      });
    },
    async func_initDefaultAddress() {
      //初始化时执行
      let shfszz = '';
      if (this.userinfo && this.userinfo.binding1 == '44') {
        shfszz = '代发快递';
      } else {
        for (let m in this.shfsshuzu) {
          if (this.userinfo.shfs == this.shfsshuzu[m].id) {
            shfszz = this.shfsshuzu[m].name;
            if (shfszz == '自取') {
              for (let zq in this.ziqufangshi) {
                if (this.userinfo.binding1 == this.ziqufangshi[zq].id) {
                  shfszz = this.ziqufangshi[zq].name;
                }
              }
            }
          }
        }
      }
      this.addressPicker.forEach((f) => {
        if (f.name === '代发快递' || f.name === '代发物流') {
          //假如收货方式为快递或者自取
          if (this.userinfo.tel) {
            f.content = {
              email: this.userinfo.email, //给content赋值
              id: f.id,
              area: this.userinfo.area,
              isdefault: 1,
              rsrvstr1: this.userinfo.attn,
              address: this.userinfo.address,
              rsrvstr2: this.userinfo.company,
              rsrvstr3: f.name,
              rsrvstr4: this.userinfo.tel,
              province: this.userinfo.province,
              city: this.userinfo.city,
            };
          } else {
            f.content = {
              email: this.userinfo.email, //给content赋值
              id: f.id,
              area: this.userinfo.area,
              isdefault: 1,
              rsrvstr1: this.userinfo.attn,
              address: this.userinfo.address,
              rsrvstr2: this.userinfo.company,
              rsrvstr3: f.name,
              rsrvstr4: this.userinfo.mobile,
              province: this.userinfo.province,
              city: this.userinfo.city,
            };
          }
          f.choose = false;
        } else {
          if (this.userinfo.tel) {
            f.content = {
              email: this.userinfo.email,
              id: f.id,
              area: this.userinfo.area,
              isdefault: 1,
              rsrvstr1: this.userinfo.attn,
              address: this.userinfo.address,
              rsrvstr2: this.userinfo.company,
              rsrvstr3: f.name,
              rsrvstr4: this.userinfo.tel,
              province: this.userinfo.province,
              city: this.userinfo.city,
            };
          } else {
            f.content = {
              email: this.userinfo.email,
              id: f.id,
              area: this.userinfo.area,
              isdefault: 1,
              rsrvstr1: this.userinfo.attn,
              address: this.userinfo.address,
              rsrvstr2: this.userinfo.company,
              rsrvstr3: f.name,
              rsrvstr4: this.userinfo.mobile,
              province: this.userinfo.province,
              city: this.userinfo.city,
            };
          }
          let wlfs = '';
          if (this.userinfo.binding1 == 44 && this.userinfo.wlid == 0) {
            wlfs = '中通快递';
          } else {
            for (let n in this.kuaidigongsi) {
              if (
                this.kuaidigongsi[n].id == this.userinfo.wlid &&
                (this.userinfo.shfs == 2 || this.userinfo.binding1 == '44')
              ) {
                wlfs = this.kuaidigongsi[n].name;
                break;
                //需要计算快递费
              }
            }
          }
          this.addressPickerString = `${
            shfszz
              ? (shfszz.indexOf('代发快递') >= 0 ? '快递物流' : shfszz) +
                '-' +
                (wlfs.indexOf('快递') <= 0 ? wlfs + '-' : '')
              : ''
          }${this.userinfo.company}-${this.userinfo.attn}-${
            this.userinfo.tel ? this.userinfo.tel : this.userinfo.mobile
          }-${this.userinfo.province}${this.userinfo.city}${
            this.userinfo.area
          }${this.userinfo.address}`;
          f.choose = false;
        }
      });
      this.addressPicker[0].choose = true;
    },
    //把用户信息传递给子组件
    async func_createAddress(params) {
      let selectAddress = this.addressPicker.find((p) => p.choose === true); //find返回this.addressPicker中p.choose为true的数据
      selectAddress.content.email = params['email'];
      selectAddress.content.address = params['Address'];
      selectAddress.content.rsrvstr1 = params['Attn'];
      selectAddress.content.rsrvstr2 = params['Company'];
      selectAddress.content.rsrvstr4 = params['Mobile'];
      selectAddress.content.province = params['province'];
      selectAddress.content.city = params['city'];
      selectAddress.content.area = params['area'];
      if (this.addressPicker[1].choose) {
        for (let i in this.kuaidigongsi) {
          if (this.kuaidigongsi[i].choose) {
            selectAddress.content.kuaidigongsi = this.kuaidigongsi[i].name;
          }
        }
      } else {
        selectAddress.content.kuaidigongsi = '';
      }
    },
    func_createAddressCancel() {
      this.func_switchAddressPicker({
        currentTarget: { dataset: { index: 0 } },
      });
    },
    func_picture(index) {
      if (index == 1) {
        this.p_img = BK1;
      } else if (index == 2) {
        this.p_img = BK2;
      } else if (index == 3) {
        this.p_img = BK3;
      } else if (index == 4) {
        this.p_img = BK4;
      } else if (index == 5) {
        this.p_img = BK5;
      } else if (index == 6) {
        this.p_img = BK6;
      } else if (index == 7) {
        this.p_img = BK7;
      } else if (index == 8) {
        this.p_img = BK8;
      } else if (index == 9) {
        this.p_img = BK9;
      } else if (index == 10) {
        this.p_img = BK10;
      }
    },
    func_picture1(index) {
      if (index == 1) {
        this.p_img = L01;
      } else if (index == 2) {
        this.p_img = L02;
      } else if (index == 3) {
        this.p_img = L03;
      } else if (index == 4) {
        this.p_img = L04;
      } else if (index == 5) {
        this.p_img = L05;
      } else if (index == 6) {
        this.p_img = L06;
      } else if (index == 7) {
        this.p_img = S01;
      } else if (index == 8) {
        this.p_img = S02;
      } else if (index == 9) {
        this.p_img = S03;
      } else if (index == 10) {
        this.p_img = S04;
      } else if (index == 11) {
        this.p_img = S05;
      } else if (index == 12) {
        this.p_img = S06;
      } else if (index == 13) {
        this.p_img = ML01;
      } else if (index == 14) {
        this.p_img = ML02;
      } else if (index == 15) {
        this.p_img = ML03;
      } else if (index == 16) {
        this.p_img = ML04;
      } else if (index == 17) {
        this.p_img = ML05;
      } else if (index == 18) {
        this.p_img = ML06;
      } else if (index == 19) {
        this.p_img = MS01;
      } else if (index == 20) {
        this.p_img = MS02;
      } else if (index == 21) {
        this.p_img = MS03;
      } else if (index == 22) {
        this.p_img = MS04;
      } else if (index == 23) {
        this.p_img = MS05;
      } else if (index == 24) {
        this.p_img = MS06;
      } else if (index == 25){
        this.p_img = cyhb;
      } else if (index == 26){
        this.p_img = tjhb;
      } else {
        this.p_img = cyhb;
      }
    },

    func_picture2(index) {
      if (index == 1) {
        this.p_img = T1;
      } else if (index == 2) {
        this.p_img = T2;
      } else if (index == 3) {
        this.p_img = T3;
      } else if (index == 4) {
        this.p_img = T4;
      }
    },
    func_init() {
      const o_menu = this.STORAGE.get('g_order_menu');
      for (let c in o_menu) {
        if (o_menu[c].choose == true) {
          this.currentProduct = o_menu[c].oef;
          for (let i in this.o_hots_h5) {
            if (this.o_hots_h5[i].value == this.currentProduct) {
              this.chanpin = this.o_hots_h5[i].name;
            }
          }
        }
      }
      if (o_menu) {
        this.o_menu = o_menu;
      } else {
        this.o_menu = [
          { oef: 'pidenv_xf', name: '标准信封', choose: true, icon: p06 },
          { oef: 'pidenv_lsf', name: '专版信封', choose: false, icon: p06 },
        ];
        this.currentProduct = 'pidenv_xf';
      }
      let cOef = '';

      for (let i in this.o_menu) {
        if (this.o_menu[i]['choose']) {
          cOef = this.o_menu[i]['oef'];
          break;
        }
      }
      for (let i in this.o_hots) {
        let count = -1;
        for (let j in this.o_hots[i].children) {
          if (this.o_hots[i].children[j]['oef'] === cOef) {
            this.o_hots[i].children[j]['choose'] = true;
            this.currentProduct = this.o_hots[i].children[j]['oef'];
            break;
          }
        }
        if (count > -1) {
          break;
        }
      }
      for (let i in this.o_menu) {
        if (this.o_menu[i]['choose']) {
          const rOpen = this.o_menu[i]['oef'];
          if (!rOpen || rOpen === 'xx') break;
          if (this.$refs[rOpen]) {
            this.$refs[rOpen].showChange();
            this.$refs[rOpen].inputChange();
            break;
          }
        }
      }
      let p_arr = [];
      for (let i in this.o_menu) {
        if (
          this.o_menu[i]['icon'] &&
          p_arr.indexOf(this.o_menu[i]['icon']) === -1
        ) {
          p_arr.push(this.o_menu[i]['icon']);
        }
      }
      this.p_list = p_arr;
      for (let j in this.o_hots) {
        if (this.o_hots[j].name == '标准信封' && this.o_hots[j].sty == true) {
          this.p_img = this.p_list[0];
          break;
        } else if (
          this.o_hots[j].name == '珠光纸烫金信封' &&
          this.o_hots[j].sty == true
        ) {
          this.p_img = this.p_list[3];
          break;
        } else if (
          this.o_hots[j].name == '标准筷子套' &&
          this.o_hots[j].sty == true
        ) {
          this.p_img = this.p_list[1];
          break;
        } else if (
          this.o_hots[j].name == '封套' &&
          this.o_hots[j].sty == true
        ) {
          this.p_img = this.p_list[2];
          break;
        } else if (
          this.o_hots[j].name == '筷子套' &&
          this.o_hots[j].sty == true
        ) {
          this.p_img = this.p_list[1];
          break;
        } else if (this.o_hots[j].children.length == 1) {
          this.p_img = this.p_list[0];
        }
      }
      if (!this.$parent.isorder) {
        this.fun_customer();
      }
    },
    async fun_customer() {
      //获取利润率参数
      const uid = this.userinfo['userid'];
      const result = await req_customer(uid);
      if (result.success) {
        if (
          result.data &&
          result.data.ProductSetting.length > 0 &&
          result.data.RangeSetting.length > 0
        ) {
          (this.tableData = result.data.RangeSetting),
            (this.product = result.data.ProductSetting);
        }
      } else {
        this.$parent.$parent.msgChange(
          'warning',
          '获取报价信息失败，请重试',
          ''
        );
      }
    },
    func_switchAddressPicker(event) {
      const { index } = event.currentTarget.dataset;
      this.addressPickerString = '';
      this.addressPicker.forEach((f, i) => {
        if (f.choose && i !== index) f.choose = false;
      });
      this.addressPicker[index].choose = true;
      switch (this.addressPicker[index].id) {
        case '1': {
          this.isdaifa = false;
          this.kuaidi100 = '';
          this.kuaidifei = 0;
          let shfszz = '';
          if (this.userinfo.binding1 == '44') {
            shfszz = '代发快递';
          } else {
            for (let m in this.shfsshuzu) {
              if (this.userinfo.shfs == this.shfsshuzu[m].id) {
                shfszz = this.shfsshuzu[m].name;
                if (shfszz == '自取') {
                  for (let zq in this.ziqufangshi) {
                    if (this.userinfo.binding1 == this.ziqufangshi[zq].id) {
                      shfszz = this.ziqufangshi[zq].name;
                    }
                  }
                }
              }
            }
          }
          let id = '';
          let wlfs = '';
          if (this.userinfo.binding1 == 44 && this.userinfo.wlid == 0) {
            wlfs = '中通快递';
            id = 1;
          } else {
            for (let n in this.kuaidigongsi) {
              if (
                this.kuaidigongsi[n].id == this.userinfo.wlid &&
                (this.userinfo.shfs == 2 || this.userinfo.binding1 == '44')
              ) {
                wlfs = this.kuaidigongsi[n].name;
                id = 1;
                break;
                //需要计算快递费
              } else {
                //无需计算快递费
                id = 2;
              }
            }
          }
          if (this.leixing == 'pidnon_fb') {
            this.kuaidifei = 0;
          } else {
            this.func_kuaidifei(id, wlfs);
          }

          this.addressPickerString = `${
            shfszz ? shfszz + '-' + (wlfs ? wlfs + '-' : '') : ''
          }${this.userinfo.company}-${this.userinfo.attn}-${
            this.userinfo.tel ? this.userinfo.tel : this.userinfo.mobile
          }-${this.userinfo.province}${this.userinfo.city}${
            this.userinfo.area
          }${this.userinfo.address}`;

          this.$refs.vadc.vadc_closes();
          break;
        }
        case '2': {
          this.$refs.vadc.vadc_json(1);
          if (this.leixing == 'pidnon_fb') {
            this.kuaidifei = 0;
          } else {
            this.func_kuaidifei(1);
          }
          this.isdaifa = true;
          this.$refs.vadc.vadc_Change();
          break;
        }
        case '3': {
          this.kuaidi100 = '';
          this.kuaidifei = 0;
          this.jianmianyunfei = 0;
          this.isdaifa = false;
          this.$refs.vadc.vadc_json(5);
          this.$refs.vadc.vadc_Change();

          break;
        }
      }
    },
    func_shuaxin() {
      this.userinfo = this.STORAGE.get('g_userInfo');
      this.func_init();
      if (this.userinfo) {
        
        this.func_initDefaultAddress();
      }
    },
  },
  mounted() {
    this.func_shuaxin();
    if (this.$parent.isorder) {
      this.o_hots.push({
        name: '特殊产品',
        xianshi: false,
        oef: '',
        dd: true,
        sty: false,
        jt: false,
        children: [{ name: '', oef: 'pidnon_fb', choose: false, sty: false }],
      });
    }
    this.o_hotss = this.o_hots;
  },
};
</script>
<style src='@/style/order.css' scoped>
</style>
<style src='@/style/order-h5.css' scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Order.vue